import React from "react";
import "./App.css";
import { ConfigProvider } from "antd";
import MorseTranslator from "./MorseTranslator";

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          // Warm Orange Primary Color
          colorPrimary: "#fa8c16",
          // Global Font Family
          fontFamily: "'DM Sans', sans-serif",
          // Rounded corners for a "cozy" feel
          borderRadius: 12,
        },
        components: {
          Button: {
            // enhancing the button shadow for that "tactile" feel
            boxShadow: "0 4px 14px rgba(250, 140, 22, 0.4)",
          },
          Card: {
            // ensuring cards have the clean, soft shadow defined in the CSS
            boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
          },
        },
      }}
    >
      <MorseTranslator />
    </ConfigProvider>
  );
};

export default App;
